/**
 * Gets a floating point value given an integer and a count of decimal points
 * @param value e.g. 2555
 * @param decimal e.g. 2
 * @returns 25.55
 */
export const getFloatValue = (value: number, decimal: number) =>
  Number.parseFloat((value / Math.pow(10, decimal)).toFixed(decimal));
